import "./sprinkles.css.ts.vanilla.css-mistica.js";
import "./empty-state.css.ts.vanilla.css-mistica.js";
var n = "_13fzrua2 _1y2v1nfb5 _1y2v1nf5y", v = {
    default: "_13fzrua3",
    largeImage: "_13fzrua4"
}, e = "_13fzrua9 _1y2v1nfc6 _1y2v1nfcm", f = "_13fzruac", _ = "_13fzrua7 _1y2v1nfc9", o = "_13fzrua5", u = "_13fzruab _1y2v1nfb7", t = {
    backgroundColor: "var(--_13fzrua0)"
};
export { n as container, v as contentVariants, e as iconContainer, f as inverseBorder, _ as largeImage, o as largeImageContainer, u as smallImage, t as vars };
